<template>
  <div class="panel-body">
    <h1 class="logo-desc">Offers</h1>

    <!-- modal add new offer -->
    <div class="container">
      <!-- Modal -->
      <div class="modal fade" id="addOfferModal" role="dialog">
        <div class="modal-dialog modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 v-if="isEditing" class="modal-title">Edit offer</h4>
              <h4 v-else class="modal-title">Add new offer</h4>
            </div>
            <div class="modal-body">
              <!-- form -->
              <form ref="form" @submit.prevent class="customWidthhundred">
                <table class="customWidthhundred">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>#</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <label for="bg_img_url">Background Image:</label>
                      </td>
                      <td>
                        <input
                          type="file"
                          class="form-control"
                          id="bg_img_url"
                          ref="bgImgUrl"
                          name="bg_img_url"
                          @change="onChangeBgImg()"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="title_text">Title Text:</label>
                      </td>
                      <td>
                        <input
                          v-model="form.title.text"
                          type="text"
                          class="form-control"
                          id="title_text"
                          placeholder="Enter title text"
                          name="title_text"
                          required
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="title_text_color">Title Text Color:</label>
                      </td>
                      <td>
                        <input
                          v-model="form.title.text_color"
                          type="color"
                          name="title_text_color"
                          class="form-control"
                          id="title_text_color"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="title_font_size">Title Font Size:</label>
                      </td>
                      <td>
                        <input
                          v-model="form.title.font_size"
                          type="number"
                          min="1"
                          placeholder="14"
                          class="form-control"
                          name="title_font_size"
                          id="title_font_size"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="image_url">Image:</label>
                      </td>
                      <td>
                        <input
                          type="file"
                          class="form-control"
                          ref="imgUrl"
                          name="image_url"
                          id="image_url"
                          @change="onChangeImg()"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="center_section_type"
                          >Center Section Type:</label
                        >
                      </td>
                      <td>
                        <select
                          v-model="form.center_section.type"
                          class="customColorSelect form-control"
                        >
                          <option value="1">text</option>
                          <option value="2">bullet point</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="form.center_section.type === '2'">
                      <td>
                        <label for="center_section_bullet_point"
                          >Center Section Bullet Point:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.center_section.bullet_point"
                          type="text"
                          name="center_section_bullet_point"
                          class="form-control"
                          id="center_section_bullet_point"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label for="center_section_text_color"
                          >Center Section Text Color:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.center_section.text_color"
                          type="color"
                          name="center_section_text_color"
                          class="form-control"
                          id="center_section_text_color"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="center_section_font_size"
                          >Center Section Font Size:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.center_section.font_size"
                          type="number"
                          min="1"
                          placeholder="14"
                          class="form-control"
                          name="center_section_font_size"
                          id="center_section_font_size"
                        />
                      </td>
                    </tr>

                    <tr v-if="form.center_section.type === '1'">
                      <td>
                        <label for="center_section_text"
                          >Center Section Text:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.center_section.text"
                          type="text"
                          placeholder="Enter center section text"
                          class="form-control"
                          name="center_section_text"
                          id="center_section_text"
                        />
                      </td>
                    </tr>

                    <tr v-if="form.center_section.type === '2'">
                      <td>
                        <label for="center_section_points"
                          >Center Section Points:</label
                        >
                      </td>
                      <td style="word-break: unset">
                        <div
                          class="d-flex"
                          v-for="(n, i) in form.center_section.points"
                          :key="i"
                        >
                          <input
                            v-model="form.center_section.points[i].text"
                            type="text"
                            placeholder="Enter center section point"
                            class="form-control"
                            name="center_section_points"
                            id="center_section_points"
                          />
                          <div style="margin-left: 1rem">
                            <a
                              v-if="i === 0"
                              href="javascript:void(0);"
                              class="btn btn-primary"
                              @click="handleAddmore()"
                              >add more</a
                            >
                            <a
                              v-else
                              href="javascript:void(0);"
                              class="btn btn-danger"
                              @click="handleRemove(i)"
                              >remove</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_text_color"
                          >Pro Button Text Color:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.text_color"
                          type="color"
                          class="form-control"
                          name="pro_button_text_color"
                          id="pro_button_text_color"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_bottom_color"
                          >Pro Button Bottom Color:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.bottom_color"
                          type="color"
                          class="form-control"
                          name="pro_button_bottom_color"
                          id="pro_button_bottom_color"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_top_color"
                          >Pro Button Top Color:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.top_color"
                          type="color"
                          class="form-control"
                          name="pro_button_top_color"
                          id="pro_button_top_color"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_show_price"
                          >Pro Button Show Price:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.show_price"
                          type="text"
                          placeholder="Enter pro button show price"
                          class="form-control"
                          name="pro_button_show_price"
                          id="pro_button_show_price"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_cut_price"
                          >Pro Button Cut Price:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.cut_price"
                          type="text"
                          placeholder="Enter pro button cut price"
                          class="form-control"
                          name="pro_button_cut_price"
                          id="pro_button_cut_price"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="pro_button_button_text"
                          >Pro Button Text:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.pro_button.button_text"
                          type="text"
                          placeholder="Enter pro button text"
                          class="form-control"
                          name="pro_button_button_text"
                          id="pro_button_button_text"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="dialog_title">Dialog Title:</label>
                      </td>
                      <td>
                        <input
                          v-model="form.dialog.title"
                          type="text"
                          placeholder="Enter dialog title"
                          class="form-control"
                          name="dialog_title"
                          id="dialog_title"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="dialog_possitive_btn"
                          >Dialog Possitive Btn:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.dialog.possitive_btn"
                          type="text"
                          placeholder="YES / OK"
                          class="form-control"
                          name="dialog_possitive_btn"
                          id="dialog_possitive_btn"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="dialog_negative_btn"
                          >Dialog Negative Btn:</label
                        >
                      </td>
                      <td>
                        <input
                          v-model="form.dialog.negative_btn"
                          type="text"
                          placeholder="NO / CANCEL"
                          class="form-control"
                          name="dialog_negative_btn"
                          id="dialog_negative_btn"
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <label for="active">Active:</label>
                      </td>
                      <td>
                        <select
                          v-model="form.active"
                          class="customColorSelect form-control"
                        >
                          <option :value="true">Active</option>
                          <option :value="false">Deactive</option>
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="2">
                        <button
                          type="submit"
                          class="btn btn-default"
                          @click="addData"
                          data-dismiss="modal"
                        >
                          Submit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="closeModal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- UPAR SAB THIK HAI -->
    <!-- loader -->
    <triangle-loader v-if="loader" />
    <!-- loader ends -->
    <!--END modal comments -->
    <table v-show="!loader" class="table table-hover">
      <thead>
        <tr>
          <th colspan="18" class="customBg">
            <button
              type="button"
              class="btn btn-float-right"
              data-toggle="modal"
              data-target="#addOfferModal"
              @click="showAddNewOfferModal"
            >
              Add new offer
            </button>
          </th>
        </tr>
        <tr>
          <th>BG Image</th>
          <th>Title Text</th>
          <th>Title Color</th>
          <th>Title Size</th>
          <th>Image</th>
          <th>Center Type</th>
          <th>Center Bullet Point</th>
          <th>Center Text Color</th>
          <th>Center Font Size</th>
          <th>Pro Btn Colors</th>
          <th>Pro Btn Show Price</th>
          <th>Pro Btn Cut Price</th>
          <th>Pro Btn Text</th>
          <th>Dialog Title</th>
          <th>Dialog Positive Btn</th>
          <th>Dialog Negative Btn</th>
          <th>Active</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(info, index) in paginatedData" :key="index">
          <td>
            <a
              v-if="info.bg_img_url"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#previewImageModal"
              @click="previewImage = info.bg_img_url"
              >Preview</a
            >
            <span v-else>No img</span>
          </td>
          <td>{{ info.title.text }}</td>
          <td>
            <span
              v-if="info.title.text_color"
              class="color-box"
              :style="{ background: info.title.text_color }"
            ></span>
            {{ info.title.text_color }}
          </td>
          <td>{{ info.title.font_size }}</td>
          <td>
            <a
              v-if="info.image_url"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#previewImageModal"
              @click="previewImage = info.image_url"
              >Preview</a
            >
            <span v-else>No img</span>
          </td>
          <td>{{ info.center_section.type }}</td>
          <td>{{ info.center_section.bullet_point }}</td>
          <td>
            <span
              v-if="info.center_section.text_color"
              class="color-box"
              :style="{ background: info.center_section.text_color }"
            ></span>
            {{ info.center_section.text_color }}
          </td>
          <td>{{ info.center_section.font_size }}</td>
          <td>
            <div>
              Text:
              <span
                v-if="info.pro_button.text_color"
                class="color-box"
                :style="{ background: info.pro_button.text_color }"
              ></span>
              {{ info.pro_button.text_color }}
            </div>
            <hr>
            <div>
              Bottom:
              <span
                v-if="info.pro_button.bottom_color"
                class="color-box"
                :style="{ background: info.pro_button.bottom_color }"
              ></span>
              {{ info.pro_button.bottom_color }}
            </div>
            <hr>
            <div>
              Top:
              <span
                v-if="info.pro_button.top_color"
                class="color-box"
                :style="{ background: info.pro_button.top_color }"
              ></span>
              {{ info.pro_button.top_color }}
            </div>
          </td>
          <td>{{ info.pro_button.show_price }}</td>
          <td>{{ info.pro_button.cut_price }}</td>
          <td>{{ info.pro_button.button_text }}</td>
          <td>{{ info.dialog.title }}</td>
          <td>{{ info.dialog.possitive_btn }}</td>
          <td>{{ info.dialog.negative_btn }}</td>
          <td>
            <span
              :class="{
                'offer-active': info.active,
                'offer-deactive': !info.active,
              }"
              >●</span
            >
          </td>

          <td>
            <!-- <button
              type="button"
              @click="showModal(info)"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#myModal1"
            >
              View Comments
            </button> -->
            <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#addOfferModal"
              @click="handleEdit(info)"
            >
              Edit
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      @click="prevPage"
      :disabled="pageNumber == 0"
      type="button"
      class="btn btn-primary"
    >
      Previous
    </button>
    &nbsp;
    <button
      @click="nextPage"
      :disabled="pageNumber >= pageCount - 1"
      type="button"
      class="btn btn-primary"
    >
      Next
    </button>
    <br />
    <!-- PREVIEW IMAGE MODAL -->
    <div
      class="modal fade"
      id="previewImageModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="previewImageModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="previewImageModalLabel">
              Image preview
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img
              v-if="previewImage"
              style="max-height: 500px; max-width: 550px"
              :src="previewImage"
              alt="preview image"
            />
            <img
              v-else
              src="../images/noImageAvailable.png"
              alt="noImageAvailable"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

import "vue-loaders/dist/vue-loaders.css";
import * as VueLoaders from "vue-loaders";
Vue.use(VueLoaders);

import { offerForm } from "../static/offerForm";
export default {
  name: "offer",
  props: {
    size: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  data() {
    return {
      showmodal: false,
      userInfo: null,
      showQueryModalData: false,
      pageNumber: 0, // default to page 0
      form: offerForm(),
      isEditing: false,
      previewImage: null,
    };
  },
  computed: {
    ...mapGetters({
      showData: "showData",
      showUsers: "showUsers",
      loader: "showLoader",
    }),
    pageCount() {
      if (this.showData.offerList) {
        let l = this.showData.offerList.length,
          s = this.size;
        return Math.ceil(l / s);
      } else {
        return 0;
      }
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      if (this.showData.offerList) {
        return this.showData.offerList.slice(start, end);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.modeSet();
    this.getOffer();
  },
  methods: {
    ...mapActions(["addOffer", "getOfferData", "setMode"]),
    getOffer: function () {
      if (this.showData.mode) {
        this.getOfferData({
          mode: this.showData.mode,
        });
      } else {
        this.getOfferData({
          mode: "dev",
        });
      }
    },
    showAddNewOfferModal() {
      Object.assign(this.form, offerForm());
      this.showQueryModalData = true;
      this.isEditing = false;
    },
    closeModal() {
      this.showQueryModalData = false;
    },
    modeSet: function () {
      this.setMode({ mode: this.showData.mode });
    },
    addData: async function () {
      let fd = new FormData();
      fd.append("bg_img_url", this.form.bg_img_url);
      fd.append("title[text]", this.form.title.text);
      fd.append("title[text_color]", this.form.title.text_color);
      fd.append("title[font_size]", this.form.title.font_size);
      fd.append("image_url", this.form.image_url);
      fd.append("center_section[type]", this.form.center_section.type);
      fd.append(
        "center_section[bullet_point]",
        this.form.center_section.bullet_point
      );
      fd.append(
        "center_section[text_color]",
        this.form.center_section.text_color
      );
      fd.append(
        "center_section[font_size]",
        this.form.center_section.font_size
      );
      fd.append("center_section[text]", this.form.center_section.text);

      this.form.center_section.points.forEach((t) => {
        fd.append("center_section[points]", t.text);
      });

      fd.append("pro_button[text_color]", this.form.pro_button.text_color);
      fd.append("pro_button[bottom_color]", this.form.pro_button.bottom_color);
      fd.append("pro_button[top_color]", this.form.pro_button.top_color);
      fd.append("pro_button[show_price]", this.form.pro_button.show_price);
      fd.append("pro_button[cut_price]", this.form.pro_button.cut_price);
      fd.append("pro_button[button_text]", this.form.pro_button.button_text);
      fd.append("dialog[title]", this.form.dialog.title);
      fd.append("dialog[possitive_btn]", this.form.dialog.possitive_btn);
      fd.append("dialog[negative_btn]", this.form.dialog.negative_btn);
      fd.append("active", this.form.active);
      if (this.isEditing) {
        fd.append("_id", this.form._id);
      }

      try {
        const response = await this.addOffer({
          mode: this.showData.mode,
          formData: fd,
          edit: this.isEditing,
        });
        if (response) {
          this.getOffer();
          Object.assign(this.form, offerForm());
        }
      } catch (err) {
        return err;
      }
    },
    showModal: function (info) {
      this.showmodal = true;
      this.userInfo = info;
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    handleAddmore() {
      this.form.center_section.points.push({ text: "" });
    },
    handleRemove(ind) {
      this.form.center_section.points = this.form.center_section.points.filter(
        (v, i) => i !== ind
      );
    },
    onChangeBgImg() {
      this.form.bg_img_url = this.$refs.bgImgUrl.files[0];
    },
    onChangeImg() {
      this.form.image_url = this.$refs.imgUrl.files[0];
    },
    handleEdit(form) {
      Object.assign(this.form, offerForm());
      const newForm = JSON.parse(JSON.stringify(form));
      this.form = newForm;
      this.showQueryModalData = true;
      this.isEditing = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-desc {
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 0.6px;
  text-align: center;
  color: #494949;
  padding: 14px 0px 14px 18px;
}
.customAlignLeft {
  text-align: left;
}
.btn-float-right {
  float: right;
}
.customBg {
  background: #ffffff;
  color: black;
}
.customWidthhundred {
  width: 100%;
  line-height: 0;
}
.customColorSelect {
  color: #353434;
}
/* Rounded sliders */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Rounded slider end */
/*pagination*/
.pagination {
  float: left;
}
.page-item {
  float: left;
}
/* table style */
.table-fill {
  background: white;
  border-radius: 3px;
  border-collapse: collapse;
  height: 320px;
  margin: auto;
  max-width: 600px;
  padding: 5px;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  animation: float 5s infinite;
}

th {
  color: #d5dde5;
  background: #1b1e24;
  border-bottom: 4px solid #9ea7af;
  border-right: 1px solid #343a45;
  font-size: 23px;
  font-weight: 100;
  padding: 24px;
  text-align: left;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  vertical-align: middle;
}

th:first-child {
  border-top-left-radius: 3px;
}

th:last-child {
  border-top-right-radius: 3px;
  border-right: none;
}

tr {
  border-top: 1px solid #c1c3d1;
  border-bottom: 1px solid #c1c3d1;
  color: #666b85;
  font-size: 16px;
  font-weight: normal;
  text-shadow: 0 1px 1px rgba(256, 256, 256, 0.1);
}

tr:hover td {
  background: #4e5066;
  color: #ffffff;
  border-top: 1px solid #22262e;
}

tr:first-child {
  border-top: none;
}

tr:last-child {
  border-bottom: none;
}

tr:nth-child(odd) td {
  background: #ebebeb;
}

tr:nth-child(odd):hover td {
  background: #4e5066;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 3px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 3px;
}

td {
  background: #ffffff;
  padding: 20px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 18px;
  text-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #c1c3d1;
  word-break: break-all;
}

td:last-child {
  border-right: 0px;
}

th.text-left {
  text-align: left;
}

th.text-center {
  text-align: center;
}

th.text-right {
  text-align: right;
}

td.text-left {
  text-align: left;
}

td.text-center {
  text-align: center;
}

td.text-right {
  text-align: right;
}

td .d-flex {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.offer-active {
  color: green;
  font-size: 30px;
}

.offer-deactive {
  color: red;
  font-size: 30px;
}

.color-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 1px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
